import ImageLightbox from '../ImageLightbox/ImageLightbox';
import { galleryImages } from '../../data/galleryImages';
import { useImageLightbox } from '../../hooks/useImageLightbox';

import './Gallery.css';

function Gallery() {
  const lightbox = useImageLightbox(galleryImages);

  return (
    <section className="gallery">
      <div className="gallery__intro">
        <p className="gallery__description">
          Explore the villa, its interiors, outdoor spaces and the peaceful
          surroundings of Orahovac and the Bay of Kotor.
        </p>
      </div>

      <div className="gallery__grid">
        {galleryImages.map((image, index) => (
          <button
            className="gallery__item"
            type="button"
            key={image.id}
            onClick={() => lightbox.open(index)}
            aria-label={`Open ${image.alt}`}
          >
            <img
              src={image.src}
              alt={image.alt}
              className="gallery__image"
              loading={index < 3 ? 'eager' : 'lazy'}
              decoding="async"
            />
          </button>
        ))}
      </div>

    <ImageLightbox
      activeIndex={lightbox.activeIndex}
      images={galleryImages}
      isOpen={lightbox.isOpen}
      onClose={lightbox.close}
    />
    </section>
  );
}

export default Gallery;
